import { render } from "./DeleteCollection.vue?vue&type=template&id=cd978484&scoped=true"
import script from "./DeleteCollection.vue?vue&type=script&lang=js"
export * from "./DeleteCollection.vue?vue&type=script&lang=js"

import "./DeleteCollection.vue?vue&type=style&index=0&id=cd978484&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd978484"]])

export default __exports__